export const processTextForLinks = (text) => {
	const Rexp = /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?/=~_|!:,.;]*)[-A-Z0-9+&@#/%=~_|])/ig;
	return text.replace(Rexp, "<a href='$1' target='_blank'>$1</a>");
}
